import { trpc } from '@/lib/trpc';

const useResetPassword = () => {
	const { mutate, isPending, error } = trpc.user.resetPassword.useMutation();

	return {
		resetPassword: mutate,
		resetPasswordLoading: isPending,
		resetPasswordError: error,
	};
};

export default useResetPassword;
